import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AccountDetailsPage, { getDefaultPageUI } from "components/pages/AccountDetailsPage";
import Classes, { Account } from "model";

export default function CaptureAccountsDetailsModal(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const account = Account.getDefaultBrandedAccountByType("checking");

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "AccountDetailsModal")
        //.update([ "modal", "data" ], Account.initByType("0"))
        .update([ "modal", "data" ], account)
        .submit();

    return <AccountDetailsPage ui={ ui } />
}